module.exports = __webpack_public_path__ + "media/dashboard/assets/images/menu-icons/menu-8476872212d2560de769ecef7c8b5ae6.svg";